import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../../js/app/react/validators';

import View from './DoYouHavePensionView';
import {
  currentClientId,
  data2,
  data as dataSelector,
  isPopulatedSelector,
  stepsToSkipSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY } from '../PensionWorkflowConstants';
import * as PersonalInfoConstants from '../../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  shouldAlwaysSkip: stepsToSkipSelector(state, ownProps).Pensions,
  clientId: currentClientId(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  pensions: dataSelector(state, ownProps)(`${BACKEND_KEY}`) || [],
  hasPension: data2(state, ownProps)(`${BACKEND_KEY}.HasPension`),
  alreadyHasPensionData: !!data2(state, ownProps)(`${BACKEND_KEY}.AlreadyHasPensionData`),
  hasFamily:
    data2(state, ownProps)(`${PersonalInfoConstants.BACKEND_KEY}.HasPartner`) ||
    data2(state, ownProps)(`${PersonalInfoConstants.BACKEND_KEY}.HasChildren`),
});
const mapDispatchToProps = dispatch => ({
  preprocessData: (clientId, pensions, store2) => {
    if (pensions.length > 0) {
      store2(
        {
          [BACKEND_KEY]: {
            HasPension: true,
            AlreadyHasPensionData: true,
          },
        },
        clientId,
      );
    }
  },
  store2: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
});

const DoYouHavePensionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);

DoYouHavePensionContainer.propTypes = {
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired),
};

export default DoYouHavePensionContainer;
